import { render } from "./OverOns.vue?vue&type=template&id=d4c14948"
import script from "./OverOns.vue?vue&type=script&lang=js"
export * from "./OverOns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__